<template>
  <div id="ContactPersonInformation">
    <div class="navBars">
      <img src="../assets/leftRun.png" @click="backFn">
      <p>联系人信息</p>
    </div>
    <div>
      <h4>WhatsApp信息</h4>
      <div><p>WhatsApp名称</p><p>{{ getData.name }}</p></div>
      <div><p>国家</p><p>{{ getData.countryname }}</p></div>
      <div><p>WhatsApp号码</p><p><span v-show="getData.mobile">+ {{getData.mobileareacode}} {{getData.mobile}}</span></p></div>
    </div>
    <div class="zidingyi">
      <h4>自定义信息</h4>
      <div><p>备注名</p><p><span>{{ getData.remark }}</span><img src="../assets/run.png" @click="runModify"></p></div>
      <div><p>国家</p><p><span>{{ getData.countryname }}</span><img src="../assets/run.png" @click="runModify"></p></div>
      <div><p>手机号</p><p><span>{{ getData.mobile }}</span><img src="../assets/run.png" @click="runModify"></p></div>
      <div><p>邮箱</p><p><span>{{ getData.email }}</span><img src="../assets/run.png" @click="runModify"></p></div>
      <div><p>公司</p><p><span>{{ getData.companyname }}</span><img src="../assets/run.png" @click="runModify"></p></div>
      <div>
        <p>标签</p>
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="tagWraps">
            <van-tag v-for="item in getData.TagAll" :key="item.Id" type="info">{{ item.name }}</van-tag>
          </div>
          <img src="../assets/run.png" @click="runModify">
        </div>
      </div>
      <div><p>负责人</p><p>{{ fuzeren }}</p></div>
      <van-button v-if="getData.companyname && (getData.mobile || getData.email)" type="info" size="middle" class="addbtn"  @click="CompanyAddCRMFn2">加入线索</van-button>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant-green'
import {CompanyAddCRM2} from '../http/api'
export default {
  data () {
    return {
      getData: {},
      fuzeren: '',
      CompanyAddCRMData2: {
        companyname: '',
        countrycode: '',
        username: '',
        mobile: '',
        email: '',
        remark: 0
      }
    }
  },
  methods: {
    runModify () {
      this.$router.push({path: '/ModifyContactPerson'})
    },
    CompanyAddCRMFn2 () {
      this.CompanyAddCRMData2.companyname = this.getData.companyname
      this.CompanyAddCRMData2.countrycode = this.getData.countrycode
      this.CompanyAddCRMData2.username = this.getData.name
      this.CompanyAddCRMData2.mobile = this.getData.mobile
      this.CompanyAddCRMData2.email = this.getData.email
      this.CompanyAddCRMData2.remark = this.getData.remark
      CompanyAddCRM2(this.CompanyAddCRMData2, 'has').then(response => {
        if (response.code === 200) {
          Toast('操作成功')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    backFn () {
      this.$router.push({path: '/Chat'})
    }
  },
  mounted () {
    let datas = JSON.parse(localStorage.getItem('userMsg'))
    if (datas) {
      this.getData = datas
    }
    this.fuzeren = localStorage.getItem('fuzeren')
  }
}
</script>
<style scoped>
.navBars{color: #303133;font-weight: bold;font-size: 16px;padding: 14px 10px !important;display: flex;align-items: center;border-bottom: 1px solid #E1E5ED;}
.navBars>div>span{margin: 0 8px;}
.navBars img{cursor: pointer;margin-right: 14px;}
#ContactPersonInformation{background-color: #F2F4F7;}
#ContactPersonInformation>div{padding: 10px 4%;background-color: #fff;}
h4{font-size: 16px;color: #303133;font-weight: bold;}
#ContactPersonInformation>div>div{margin-top: 8px;border-bottom: 1px solid #E1E5ED;padding-bottom: 10px;}
#ContactPersonInformation>div>div>p:nth-child(1){color: #919499;margin-bottom: 4px;}
#ContactPersonInformation>div>div>p:nth-child(2){color: #333;display: flex;align-items: center;justify-content: space-between;margin-top: 6px;}
.zidingyi{margin-top: 16px;}
.addbtn{width: 100%;margin: 20px auto 10px;display: block;}
.tagWraps{display: flex;flex-wrap: wrap;flex-direction: row}
.tagWraps>span{margin: 0 4px 4px 0;}
</style>



// WEBPACK FOOTER //
// src/view/ContactPersonInformation.vue